import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-navy-light py-20 px-4 border-t border-white/5" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="flex items-center gap-3 mb-8" data-id="element-125">
          <AlertTriangle className="w-8 h-8 text-danger" data-id="element-126" />
          <h2 className="text-2xl md:text-3xl font-headline font-bold text-white uppercase tracking-wide" data-id="element-127">
            Sección 1: La Confrontación con la Realidad
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-128">
          <p data-id="element-129">
            Si eres un padre con un hijo entre 8 y 16 años que{' '}
            <span className="text-white font-bold" data-id="element-130">"la rompe"</span> en la
            cancha, seguramente has sentido este nudo en el estómago:
          </p>

          <div className="bg-navy p-6 rounded-lg border-l-4 border-danger/70 shadow-lg" data-id="element-131">
            <p className="italic text-gray-200" data-id="element-132">
              "Ves a niños con la mitad del talento de tu hijo, pero con padres
              que tienen mejores conexiones o chequeras más grandes, quedándose
              con los puestos titulares en los mejores equipos."
            </p>
          </div>

          <p data-id="element-133">
            Ves a tu hijo esforzarse cada entrenamiento, solo para seguir
            estancado en el nivel "Recreational" o en una academia local donde
            el entrenador solo se sabe el nombre de tu hijo cuando toca pagar la
            cuota.
          </p>

          <p className="font-bold text-white text-xl md:text-2xl border-b border-danger/30 pb-4 inline-block" data-id="element-134">
            Tengo una verdad amarga para ti:
          </p>

          <p data-id="element-135">
            En los Estados Unidos, el fútbol no es un deporte de "suerte".{' '}
            <span className="text-danger font-bold" data-id="element-136">
              Es un sistema de pago por visibilidad.
            </span>{' '}
            Si no conoces las métricas secretas que los scouts anotan en su
            libreta, tu hijo seguirá siendo un "talento silencioso" hasta que
            sea demasiado tarde.
          </p>
        </div>
      </div>
    </section>;
}